import LinkifiedText from './LinkifiedText';

export default LinkifiedText;
